import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { ProductWithImage } from 'shared/src/api/types'

import { SANS_SERIF_FONT_FAMILY } from '../styles'
import { ProductViews } from 'components/ProductViews'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#2a2e31',
    height: 166,
    width: 120,
    position: 'relative',
  },
  image: {
    height: '66.7%',
    objectFit: 'cover',
    backgroundColor: '#ffffff',
  },
  overlay: {
    position: 'absolute',
    height: '66.7%',
    width: '100%',
    background: '#2A2E31',
    opacity: 0.16,
  },
  views: {
    marginLeft: 5,
    position: 'absolute',
  },
  text: {
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 8,
    height: '33.3%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontFamily: SANS_SERIF_FONT_FAMILY,
    fontWeight: 700,
  },
  brand: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 600,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  name: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: 12,
    fontWeight: 500,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})

interface Props {
  product: ProductWithImage
  className?: string
}

export const Product: FC<Props> = flowMax(
  addDisplayName('Product'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ product: { image, brandName, name, views }, className, classes }) => (
    <div className={cx(classes.container, className)}>
      <img src={image.full} alt="" className={classes.image} />
      <div className={classes.overlay} />
      {views != null && views > 0 && (
        <ProductViews views={views} className={classes.views} />
      )}
      <div className={classes.text}>
        <p className={classes.brand}>{brandName}</p>
        <p className={classes.name}>{name}</p>
      </div>
    </div>
  )
)
